<script>
    import MediaQuery from "svelte-media-query";
    import { Swiper, SwiperSlide, } from 'swiper/svelte';
    import { Navigation, Pagination, Scrollbar, A11y,FreeMode, Autoplay } from 'swiper';
    import 'swiper/swiper.scss';
let teams =[
    {
    Name: "4EVER ESPORTS",
    shortName: "T4E",
    logo:"4-ever-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name: "ARK ESPORTS",
    shortName: "ARK",
    logo:"ark-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name: "ASLAA ESPORTS",
    shortName: "ASLAA",
    logo:"aslaa-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name: "BAD DEVILS",
    shortName: "BD",
    logo:"bad-devils@2x.png",
    background: "bg-shape.png"
},
{
    Name: "BIG BROTHER ESPORTS",
    shortName: "BB",
    logo:"big-brother-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name:  "CELSIUS ESPORTS",
    shortName: "CEL",
    logo:"0028-celsius-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name: "ENIGMA GAMING",
    shortName: "EG",
    logo:"enigma-gaming@2x.png",
    background: "bg-shape.png"
},
{
    Name: "GLOBAL ESPORTS",
    shortName: "GE",
    logo:"global-esports-2@2x.png",
    background: "bg-shape.png"
},
{
    Name: "GODLIKE ESPORTS",
    shortName: "GL",
    logo:"godlike-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name: "GODS REIGN",
    shortName: "GODS",
    logo:"gods-reign@2x.png",
    background: "bg-shape.png"
},
{
    Name: "HYDERABAD HYDRAS",
    shortName: "HH",
    logo:"hyderabad-hydras@2x.png",
    background: "bg-shape.png"
},
{
    Name: "MARCOS GAMING",
    shortName: "MG",
    logo:"marcos-gaming@2x.png",
    background: "bg-shape.png"
},
{
    Name: "MIDWAVE ESPORTS",
    shortName: "MW",
    logo:"midwave@2x.png",
    background: "bg-shape.png"
},
{
    Name: "OR ESPORTS",
    shortName: "OR",
    logo:"or-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name: "RECKONING ESPORTS",
    shortName: "RGE",
    logo:"reckoning-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name: "REVENANT ESPORTS",
    shortName: "RNT",
    logo:"revenant-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TEAM ATOM",
    shortName: "ATOM",
    logo:"team-atom@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TEAM CHIEF YT",
    shortName: "CY",
    logo:"c-hi-ef-yt@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TEAM GENESIS",
    shortName: "GEN",
    logo:"team-genesis@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TEAM INSANE ESPORTS",
    shortName: "TIE",
    logo:"team-insane-esports@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TEAM MAVI",
    shortName: "TM",
    logo:"team-mavi@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TEAM S8UL",
    shortName: "S8UL",
    logo:"s-8-ul@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TEAM TAMILAS",
    shortName: "TT",
    logo:"team-tamilas@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TEAM X SPARK",
    shortName: "TX",
    logo:"team-x-spark@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TRUE RIPPERS ESPORTS",
    shortName: "TR",
    logo:"true-rippers@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TRY HARD",
    shortName: "TH",
    logo:"try-hard@2x.png",
    background: "bg-shape.png"
},
{
    Name: "TWOB",
    shortName: "TWOB",
    logo:"twob@2x.png",
    background: "bg-shape.png"
},
{
    Name: "UDOG INDIA",
    shortName: "UDOG",
    logo:"u-dog-india-2@2x.png",
    background: "bg-shape.png"
},
{
    Name: "UNITED 4 GLORY",
    shortName: "U4G",
    logo:"team-u-4-g@2x.png",
    background: "bg-shape.png"
},
{
    Name: "VELOCITY GAMING",
    shortName: "VLT",
    logo:"velocity-gaming@2x.png",
    background: "bg-shape.png"
},
{
    Name: "XO UDA",
    shortName: "XOUDA",
    logo:"xo-uda@2x.png",
    background: "bg-shape.png"
},
{
    Name: "ZERO GRAVITY",
    shortName: "ZG",
    logo:"team-zero-gravity@2x.png",
    background: "bg-shape.png"
}]

</script>
<section class="invited-teams">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h1 class="title">Invited teams</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <MediaQuery query="(max-width: 480px)" let:matches>
                    {#if matches}
                    <Swiper 
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    pagination={{
                      clickable: true,
                    }}
                    navigation={true}
                    modules={[Autoplay, Pagination, Navigation]}
                    class="teams-slider"
                        breakpoints='{{
                            "320": {
                            "slidesPerView": 1,
                            },
                            "480": {
                            "slidesPerView": 1,
                            }}}'
                        >
                        {#each Array(Math.ceil(teams.length / 4)) as _, i}
                            <SwiperSlide>
                                <div class="teams-container d-flex justify-content-center" style="flex-wrap: wrap ;">
                                    {#each teams.slice(((i*1)*4),((i*4)+4)) as team, i}
                                        <div class="team-card" style="background:url(images/teams/bg/{team.background});">
                                            <div class="short-name">
                                                <p>{team.shortName}</p>
                                            </div>
                                            <div class="team-logo">
                                                <img src="images/teams/logos/{team.logo}" alt="{team.logo}">
                                            </div>
                                            <div class="invite-team-name">
                                                <p>{team.Name}</p>
                                            </div>
                                        </div>
                                    {/each}
                                </div>
                            </SwiperSlide>
                        {/each}
                    </Swiper>
                    {:else}
                        <div class="teams-container d-flex justify-content-center" style="flex-wrap: wrap ;">
                            {#each teams as team, i}
                                <div class="team-card" style="background:url(images/teams/bg/{team.background}); background-size: 100% 100%;">
                                    <div class="short-name">
                                        <p>{team.shortName}</p>
                                    </div>
                                    <div class="team-logo">
                                        <img src="images/teams/logos/{team.logo}" alt="{team.logo}">
                                    </div>
                                    <div class="invite-team-name">
                                        <p>{team.Name}</p>
                                    </div>
                                </div>
                            {/each}
                        </div>
                    {/if}
                </MediaQuery>
            </div>
        </div>
    </div>
</section>